import { HeaderStyled } from './styled';

import clsx from 'clsx';

interface HeaderProps {
  className?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

const Header = ({ className, left, right }: HeaderProps) => {
  return (
    <HeaderStyled className={clsx('Header', className)}>
      <div className="left">{left && left}</div>
      <div className="right">{right && right}</div>
    </HeaderStyled>
  );
};

export default Header;
